import StyledTextFieldWithTitle from "@/modules/common/components/input/styled-text-field-with-title";
import { HospitalityTypes, RentalTags } from "@/modules/property-tracks/types";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import {
  Control,
  Controller,
  UseFormSetValue,
  useWatch,
} from "react-hook-form";

function EditFinancialInfoForm({
  control,
  setValue,
}: Readonly<{ control: Control<any>; setValue: UseFormSetValue<any> }>) {
  const isHospitality =
    useWatch({ control, name: "rentalTag" }) === "hospitality";

  return (
    <>
      <Controller
        control={control}
        name="contractSellingPrice"
        render={({ field, fieldState }) => (
          <StyledTextFieldWithTitle
            {...field}
            formatNumeric
            title="Contract Selling Price"
            placeholder="Contract Selling Price"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            size="small"
            slotProps={{
              input: {
                endAdornment: <Typography>EGP</Typography>,
              },
            }}
          />
        )}
      />

      <Controller
        control={control}
        name="actualSellingPrice"
        render={({ field, fieldState }) => (
          <StyledTextFieldWithTitle
            {...field}
            formatNumeric
            title="Actual Selling Price"
            placeholder="Actual Selling Price"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            size="small"
            slotProps={{
              input: {
                endAdornment: <Typography>EGP</Typography>,
              },
            }}
          />
        )}
      />
      <Controller
        control={control}
        name="forcastedRentalUnits"
        render={({ field, fieldState }) => (
          <StyledTextFieldWithTitle
            {...field}
            title="Forcasted Rental Units"
            placeholder="Forcasted Rental Units"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            size="small"
          />
        )}
      />
      <Controller
        control={control}
        name="rentalTag"
        render={({ field, fieldState }) => (
          <FormControl error={!!fieldState.error}>
            <FormLabel>Rental Type</FormLabel>
            <RadioGroup
              {...field}
              sx={{ flexDirection: "row" }}
              onChange={(e) => {
                field.onChange(e);
                if (e.target.value !== RentalTags.hospitality) {
                  setValue("hospitalityType", undefined);
                }
              }}
            >
              {Object.entries(RentalTags).map(([key, label]) => (
                <FormControlLabel
                  key={key}
                  value={key}
                  control={<Radio />}
                  label={label}
                />
              ))}
            </RadioGroup>
          </FormControl>
        )}
      />
      {isHospitality && (
        <Controller
          control={control}
          name="hospitalityType"
          render={({ field, fieldState }) => (
            <FormControl error={!!fieldState.error}>
              <FormLabel>Hospitality Type *</FormLabel>
              <RadioGroup {...field} sx={{ flexDirection: "row" }}>
                {Object.entries(HospitalityTypes).map(([key, label]) => (
                  <FormControlLabel
                    key={key}
                    value={key}
                    control={<Radio />}
                    label={label}
                  />
                ))}
              </RadioGroup>
              {fieldState.error && (
                <FormHelperText>{fieldState.error.message}</FormHelperText>
              )}
            </FormControl>
          )}
        />
      )}
    </>
  );
}

export default EditFinancialInfoForm;
